export const FILE_URL = process.env.REACT_APP_FILE_URL;
export const API_URL = (process.env.REACT_APP_API_URL || "http://localhost:3001") + "/v1";
